import React from 'react'

export const Icon = props => <img src={`${props.imageLink}`} />

export default Icon
